'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

import { Header } from '@/shell/header/Header';

interface AppShellProps {
    children: ReactNode;
    showHeader?: boolean;
    showFooter?: boolean;
    contentBg?: string;
}

export function AppShell({ children, showHeader = false, showFooter = false, contentBg = 'bg-white' }: AppShellProps) {
    const pathname = usePathname();
    const footerLinkClass = (href: string) =>
        `tp-footer-link ${pathname?.startsWith(href) ? 'tp-footer-link-active' : ''}`;

    return (
        <div className="h-full w-full flex flex-col overflow-hidden" style={{ maxWidth: '100vw', minWidth: 0 }}>
            {showHeader && <Header />}
            <main className={`flex-1 min-h-0 ${contentBg} w-full overflow-y-hidden overflow-x-hidden`} style={{ maxWidth: '100vw', minWidth: 0 }}>
                {children}
            </main>
            {showFooter && (
                <footer id="shell-footer" className="w-full py-4 sm:py-6 border-t-2 border-[#FFCC33] bg-white mt-auto flex-shrink-0">
                    <div className="tp-container flex items-center justify-center gap-4 md:gap-6">
                        <Link href="/terms" className={footerLinkClass('/terms')}>
                            Terms & Conditions
                        </Link>
                        <Link href="/privacy-policy" className={footerLinkClass('/privacy-policy')}>
                            Privacy Policy
                        </Link>
                    </div>
                </footer>
            )}
        </div>
    );
}

